export default "__VITE_ASSET__DJCQ4tZE__"